import UserPositions from "./UserPositions";

export default UserPositions;
